// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItemFooter__NavigationItem__2Hil-","active":"NavigationItemFooter__active__21eZU"};